
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chatbot",
      function () {
        return require("private-next-pages/chatbot.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chatbot"])
      });
    }
  